/**
 * Pure helpers for the persisted pending-task list (see usePendingTasks).
 */
import type { PendingTask } from './chatConstants';

/** Stored tasks older than this are dropped on load. */
export const PENDING_TASK_MAX_AGE_MS = 24 * 60 * 60 * 1000;

/**
 * Tasks to keep after reading storage: everything already in memory, plus
 * stored tasks younger than a day that aren't in memory yet.
 */
export function mergeStoredPendingTasks(
  existing: PendingTask[],
  stored: PendingTask[],
  now: number,
): PendingTask[] {
  const fresh = stored.filter((task) => now - task.createdAt < PENDING_TASK_MAX_AGE_MS);
  const merged = [...existing];
  fresh.forEach((task) => {
    if (!merged.find((t) => t.taskId === task.taskId)) {
      merged.push(task);
    }
  });
  return merged;
}
